const config = {
  'dsa': require('./dsa').default,
  'dsa-sandbox': require('./dsa-sandbox').default,
  'dsapos': require('./dsapos').default,
  'dsapos-sandbox': require('./dsapos-sandbox').default,
}

export default config;